import { useState } from 'react';

import ProductInUseDialog from '#/modules/crmMgmt/product/components/ProductInUseDialog';

/** 呼叫端用：`showInUse(details)` 開啟，`InUseDialogHost` 放進 JSX。 */
function useProductInUseDialog() {
  const [inUse, setInUse] = useState(null);
  const InUseDialogHost = (
    <ProductInUseDialog
      open={Boolean(inUse)}
      onOpenChange={(next) => {
        if (!next) {
          setInUse(null);
        }
      }}
      inUse={inUse}
    />
  );
  return { showInUse: setInUse, InUseDialogHost };
}

export default useProductInUseDialog;
